export default "__VITE_ASSET__DG36jU1s__"